export default {
  general: {
    showFavourites: true,
    showHomeButton: true,
    autoplayAssetViewer: true,
    propertyModalViewImagesDisclaimer: "Overlay indicates obscured view",
    showArtistImpressionText: false,
  },

  filter: {
    enabled: true,

    propertyType: false,
    propertyView: true,
    propertyLotSize: false,
    propertyPriceRange: true,
    propertyStatus: true,
    dwellingDisplayName: true,
    dwellingBeds: true,
    dwellingBaths: true,
    dwellingCars: true,
    dwellingSize: true,
    dwellingPrice: true,
    dwellingHouseDesign: true,
  },

  labels: {
    dwellingLabel: { en: "Apartment Type" },
    dwellingDesign: { en: "Collection" },
    propertyLabel: { en: "Unit No." },
    propertySize: { en: "Total Area" },
    frontage: { en: "Internal Area" },
    frontageSuffix: { en: "m<sup>2</sup>" },
    depth: { en: "External Area" },
    depthSuffix: { en: "m<sup>2</sup>" },
    viewLabel: { en: "Orientation" },
  },

  rightSidebar: {
    propertyGuide: {
      active: false,
    },
  },

  markers: {
    notReleased: {
      color: "#7f7f7f",
      hide: false,
      icon: false,
      pulse: false,
      label: {
        en: "Not Released",
      },
    },
    comingSoon: {
      color: "#82aeeb",
      hide: false,
      icon: false,
      pulse: false,
      label: {
        en: "Coming Soon",
      },
    },
    available: {
      color: "#6ed46b",
      hide: false,
      icon: false,
      pulse: true,
      label: {
        en: "Available",
      },
    },
    onHold: {
      color: "#f38433",
      hide: false,
      icon: false,
      pulse: false,
      label: {
        en: "On Hold",
      },
    },
    sold: {
      color: "#c82133",
      hide: false,
      icon: false,
      pulse: false,
      label: {
        en: "Sold",
      },
    },
  },

  skipOnlyChildLivingOptions: true,
};
